import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getAccessToken } from '../helpers/localStorage';
import { IN_TESTING_MODE, TEST_AUTH_TOKEN } from '../tests/constants';
import { filterTotalLossAssistEvents } from './helpers';

// Separate base query for main server calls
const mainServerBaseQuery = fetchBaseQuery({
  baseUrl: '', // Empty base URL to use relative paths
  prepareHeaders: async (headers) => {
    // pass test token when running locally
    const token = IN_TESTING_MODE ? TEST_AUTH_TOKEN : await getAccessToken();
    if (token) {
      headers.set('Authorization', token);
    }
    return headers;
  },
});

// Separate API for main server calls
export const mainServerAssistApi = createApi({
  reducerPath: 'mainServerAssistApi',
  baseQuery: mainServerBaseQuery,
  tagTypes: ['UserUpdate', 'AdminUpdate'],
  endpoints: (builder) => ({
    updateAdminAssistsViaMainServer: builder.mutation({
      query: ({ assists }) => ({
        url: '/api/organization/adminassists',
        method: 'PUT',
        body: assists,
      }),
      invalidatesTags: ['AdminUpdate'],
    }),
    getAdminAssists: builder.query({
      query: () => '/api/organization/adminassists',
      providesTags: ['AdminUpdate'],
      transformResponse: (response, __, arg) => {
        const { hasTotalLossEnabled } = arg;
        if (!hasTotalLossEnabled) {
          return {
            ...response,
            data: filterTotalLossAssistEvents(response),
          };
        }
        return response;
      },
    }),
    getUserAssistRule: builder.query({
      query: ({ userId }) => `/api/user/userassists/${userId}`,
      providesTags: ['AdminUpdate', 'UserUpdate'],
      transformResponse: (response, __, arg) => {
        const { hasTotalLossEnabled } = arg;
        if (!hasTotalLossEnabled) {
          return {
            ...response,
            data: filterTotalLossAssistEvents(response),
          };
        }
        return response;
      },
    }),
    updateUserAssistRule: builder.mutation({
      query: ({ eventTypeArray, userId }) => ({
        url: `/api/user/userassists/update/${userId}`,
        method: 'PUT',
        body: eventTypeArray,
      }),
      invalidatesTags: ['UserUpdate'],
    }),
  }),
});

export const {
  useGetAdminAssistsQuery,
  useGetUserAssistRuleQuery,
  useUpdateUserAssistRuleMutation,
  useUpdateAdminAssistsViaMainServerMutation,
} = mainServerAssistApi;
